import React from "react";
import PrivateRoute from "../withPrivateRoute";
import styled from "styled-components";
import { Spin } from "antd";

const InitalLoader = styled.div`
  min-height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Homepage = () => {
  return (
    <InitalLoader>
      <Spin size="large" className="loader" />
    </InitalLoader>
  );
};
export default PrivateRoute(Homepage);
